import { createAction, props } from '@ngrx/store';
import { Product, ProductCardType, ProductsResult } from '../../models';

export const LoadProducts = createAction('[Products] Load Products');
export const LoadProductsSuccess = createAction('[Products] Load Products Success', props<{ Products: any }>());
export const LoadProductsFail = createAction('[Products] Load Products Fail', props<{ error: any }>());

export const LoadMoreProducts = createAction('[Products] Load More Products');

export const LoadProductsForCollection = createAction('[Products] Load Products For Collection', props<{ handle: string }>());
export const LoadProductsForCollectionSuccess = createAction(
  '[Products] Load Products For Collection Success',
  props<{ Products: ProductsResult; loadMore?: boolean }>()
);
export const LoadProductsForCollectionFail = createAction('[Products] Load Products For Collection Fail', props<{ error: any }>());

export const LoadMoreProductsForCollection = createAction('[Products] Load More Products For Collection');

export const LoadProductByHandle = createAction('[Products] Load Product By Handle', props<{ handle: string; loadDetails?: boolean }>());
export const LoadProductByHandleSuccess = createAction(
  '[Products] Load Product By Handle Success',
  props<{ product: Product; loadDetails?: boolean; handle: string }>()
);
export const LoadProductByHandleFail = createAction('[Products] Load Product By Handle Fail', props<{ error: any }>());

export const EmptyGlobalProductsSearch = createAction(
  '[Products] Empty Global Products Search',
  props<{ searchQuery: string; identifier: string }>()
);

export const LoadProductsByQuery = createAction(
  '[Products] Load Products by Query',
  props<{ searchQuery: string; identifier: string; cardType?: ProductCardType }>()
);
export const LoadProductsByQuerySuccess = createAction(
  '[Products] Load Products ByQuery Success',
  props<{ products: any; identifier: string }>()
);
export const LoadProductsByQueryFail = createAction('[Products] Load Products ByQuery Fail', props<{ error: any }>());

export const LoadProductsFiltered = createAction('[Products] Load Products Filtered', props<{ handle: string; filters: any }>());
export const LoadProductsFilteredSuccess = createAction(
  '[Products] Load Products Filtered Success',
  props<{ Products: ProductsResult; handle?: string; searchQuery?: string; loadMore?: boolean }>()
);
export const LoadProductsFilteredFail = createAction('[Products] Load Products Filtered Fail', props<{ error: any }>());

export const LoadMoreProductsFiltered = createAction('[Products] Load More Products Filtered', props<{ filters: any }>());

export const LoadProductRecommendations = createAction('[Products] Load Product Recommendations', props<{ productId: string }>());
export const LoadProductRecommendationsSuccess = createAction(
  '[Products] Load Product Recommendations Success',
  props<{ Products: any; productId: string }>()
);
export const LoadProductRecommendationsFail = createAction('[Products] Load Product Recommendations Fail', props<{ error: any }>());

export const LoadFilterdProductsByQuery = createAction(
  '[Products] Load Products by Query for catalogpage',
  props<{ searchQuery: string; after?: string }>()
);
